import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { classNames } from 'primereact/utils';

interface Props {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isSaving: boolean;
}

export const BlockSlotDialog = ({ visible, onHide, onConfirm, isSaving }: Props) => (
  <Dialog
    header='Bloquear horario'
    visible={visible}
    onHide={onHide}
    className='cancellation-dialog big-modal'
    draggable={false}
    resizable={false}
    dismissableMask
    footer={
      <div className='dialog-footer'>
        <Button label='Volver' icon='pi pi-times' onClick={onHide} className='p-button-text' disabled={isSaving} />
        <Button
          label='Confirmar bloqueo'
          icon='pi pi-check'
          onClick={onConfirm}
          className='p-button-danger'
          autoFocus
          loading={isSaving}
        />
      </div>
    }
  >
    <div className='cancellation-info warning'>
      <i className={classNames(PrimeIcons.EXCLAMATION_TRIANGLE, 'warning-icon')} />
      <p className='warning-title'>Esta acción bloqueará el horario seleccionado.</p>
      <p>Nadie podrá reservar en este horario hasta que lo desbloquees.</p>
    </div>
  </Dialog>
);
